import { makeGraphQLRequest } from '../utils/requestUtils';

export default async function createRFQ(userId, rfqInput) {
  let solNum
  let participants
  let partNum
  let niin
  let partDesc
  let drawingNums
  if (rfqInput) {
    solNum = rfqInput.solNum
    participants = rfqInput.participants
    partNum = rfqInput.partNum
    niin = rfqInput.niin
    partDesc = rfqInput.partDesc
    drawingNums = rfqInput.drawingNums
  }

  const query = `mutation createRFQ($userId: ID, $solNum: String, $participants: [String], $partNum: String, $niin: String, $partDesc: String, $drawingNums: String) { createRFQ (userId: $userId, solNum: $solNum, participants: $participants, partNum: $partNum, niin: $niin, partDesc: $partDesc, drawingNums: $drawingNums) { status msg rfqId  } }`;

  // Variables
  const variables = { userId, solNum, participants, partNum, niin, partDesc, drawingNums };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response.createRFQ;
}




// WEBPACK FOOTER //
// ./src/graphql/sendRFQ.js